import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export enum ErrorType {
	/** Authentication failure (code 100) — no/expired credentials, re-login can help. */
	Auth = 'Auth',
	/** Authorization failure (code 403) — the authenticated user lacks permission, re-login would not help. */
	Forbidden = 'Forbidden',
	Other = 'Other'
}

interface BaseError {
	type: ErrorType;
	message: string;
}

interface UserError {
	errors: string[];
	user_errors: string[];
}

@Injectable({
	providedIn : 'root'
})
export class ErrorPipeService {

	public error$: Subject<BaseError> = new Subject<BaseError>();

	public addError(errorMessage: string | BaseError): void
	{
		if (errorMessage && typeof errorMessage === 'string') {
			const errorType = ErrorPipeService.getErrorType(errorMessage);
			this.error$.next(errorType);
		} else if (typeof errorMessage === 'object' && errorMessage.type && errorMessage.type in ErrorType) {
			this.error$.next(errorMessage);
		}
	}

	public static isAuthError(error: string): boolean
	{
		return ErrorPipeService.getErrorType(error).type === ErrorType.Auth;
	}

	public static getErrorType(errorMessage: string): BaseError {
		let error: BaseError = null;
		if (errorMessage.startsWith('100: Unauthenticated access')) {
			error = { message : errorMessage, type : ErrorType.Auth };
		} else if (errorMessage.startsWith('403: ')) {
			error = { message : errorMessage, type : ErrorType.Forbidden };
		} else {
			error = { message : errorMessage, type : ErrorType.Other };
		}
		return error;
	}
}
